export const CATEGORY_SLUG_MAP = {
  "smart-gadgets": "Gadgets",
  auto: "Auto",
  furniture: "Furniture",
  travel: "Travel",
  events: "Events",
  agriculture: "Agriculture",
  manufacturing: "Manufacturing & Goods",
};

export const DEFAULT_CATEGORY = "Gadgets";

export function getCategoryFromSlug(slug) {
  if (!slug) {
    return DEFAULT_CATEGORY;
  }

  const normalized = slug.trim().toLowerCase();
  return CATEGORY_SLUG_MAP[normalized] ?? DEFAULT_CATEGORY;
}
